import { RouteFragment } from "../../../../react-core/Imports";

import { RoutingActions } from "../../../../react-core/Flux/Variables";

export interface INavigationData {
    scrollAfterNavigating: boolean;
    queryParamsObject: IQueryParamsObject;
}

export interface IQueryParamsObject {
    [queryParamName: string]: any;
}

export class Navigator {
    public static navigateTo(
        routeFragment: RouteFragment,
        navigationData: INavigationData = { scrollAfterNavigating: false, queryParamsObject: {} }
    ): void {
        const url = routeFragment.getUrl();
        this.navigateToUrl(url, navigationData);
    }

    public static navigateToUrl(
        url: string,
        navigationData: INavigationData = { scrollAfterNavigating: false, queryParamsObject: {} }
    ): void {
        const queryParameters: string[] = [];
        for (const queryParamName in navigationData.queryParamsObject) {
            const queryParamValue = navigationData.queryParamsObject[queryParamName];
            if (queryParamValue) {
                queryParameters.push(queryParamName + "=" + navigationData.queryParamsObject[queryParamName]);
            }
        }

        queryParameters.length > 0
            ? RoutingActions.navigateTo(url + "?" + queryParameters.join("&"), navigationData.scrollAfterNavigating)
            : RoutingActions.navigateTo(url, navigationData.scrollAfterNavigating);
    }

    public static navigateToAndPreserveQueryParameters(
        routeFragment: RouteFragment,
        scrollAfterNavigating = true
    ): void {
        const url = routeFragment.getUrl();
        RoutingActions.navigateTo(url + window.location.search, scrollAfterNavigating);
    }

    public static navigateToUrlAndPreserveQueryParameters(url: string, scrollAfterNavigating = true): void {
        RoutingActions.navigateTo(url + window.location.search, scrollAfterNavigating);
    }
}
